import { Gig, Organization } from "gql-gen";

import { userIsLessThan } from "interfaces/user";
import { UserInfo } from "modules/Dashboard/UserInfo";

const orgHas = (data: Gig, orgId: string, predicate: (org: Organization) => boolean) => {
  const { talentOrganization, managerOrganization, ownerOrganization, partnerOrganization } = data;

  return [talentOrganization, managerOrganization, ownerOrganization, partnerOrganization].some(
    org => org?.id === orgId && predicate(org),
  );
};

const verifiedReportEditing = (data: Gig, orgId: string) =>
  orgHas(data, orgId, org => org.verifiedReportEditing ?? false);

const unverifiedReportEditing = (data: Gig, orgId: string) =>
  orgHas(data, orgId, org => org.unverifiedReportEditing ?? false);

type Mode = 'dashboard' | 'standalone'

export const isEditable = (
  gig: Gig,
  userInfo: UserInfo,
  mode: Mode = 'dashboard'
): { editable: boolean, gigIsVerified: boolean } => {
  // See `gig_states.order` in the DB
  const gigIsVerified = gig.workflowStateOrder > 140;
  const user = userInfo.me;

  const isAssignedTalent = gig.talent?.id ? gig.talent?.id === user?.id : false;

  if (user?.isAdmin || isAssignedTalent) {
    return { editable: true, gigIsVerified };
  }

  const orgId = user?.organizationUser?.organizationId;

  if (userIsLessThan(user, "member") || !orgId) {
    return { editable: false, gigIsVerified };
  }

  if (gigIsVerified) {
    return { editable: verifiedReportEditing(gig, orgId), gigIsVerified };
  }

  if (mode === 'standalone') {
    return { editable: unverifiedReportEditing(gig, orgId), gigIsVerified };
  }

  return { editable: gig.talentOrganization?.id === orgId, gigIsVerified };
};
